import React, { useState, useEffect } from 'react';
import { Card, Col, Nav, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import Avatar from "../../components/Avatar";
// import UsersKPI from '../../components/UsersKPI';
import OrdersKPI from '../../components/OrdersKPI';
import CouponsKPI from '../../components/CouponsKPI';
import ProductsKPI from '../../components/ProductsKPI';
import RevenueKPI from '../../components/RevenueKPI';
import axios from '../../api/axios';

const Dashboard = () => {
  const [outlets, setOutlets] = useState([]);
  const [outletFilter, setOutletFilter] = useState('all');
  const [loadingOutlets, setLoadingOutlets] = useState(false);
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  useEffect(() => {
    getOutlets();
  }, []);

  const getOutlets = async () => {
    try {
      setLoadingOutlets(true);
      const token = localStorage.getItem('authToken');
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get('outlet', { headers });
      if (response?.data?.status === true) {
        const filteredOutlets = response?.data?.data?.outlets?.filter(out => out?.status === 'ACTIVE');
        // setOutlets(response?.data?.data?.outlets);
        setOutlets(filteredOutlets);
      }
    } catch (error) {
      console.error('Error fetching outlets:', error);
    } finally {
      setLoadingOutlets(false);
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <OrdersKPI 
          outlets={outlets} 
          setOutletFilter={setOutletFilter} 
          loadingOutlets={loadingOutlets} 
          outletFilter={outletFilter} 
        />
        
        <div className='mt-4'>
          <CouponsKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div>
        
        {/* <div className='mt-4'>
          <UsersKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div> */}
        
        <div className='mt-4'>
          <RevenueKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div>
        
        <div className='mt-4'>
          <ProductsKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div>
        
        <div className='mt-4'>
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;